import { createSlice } from "@reduxjs/toolkit";
import {
  searchArbitratorAllocationAction,
  submitArbitratorMappingAction,
} from "../../actions/ArbitratorAllocation/arbitratorAllocationAction";

const arbitratorAllocation = {
  cases: [],
  unmatchedCases: [],
  loading: false,
  error: "",
};

const arbitratorAllocationSlice = createSlice({
  name: "arbitratorAllocation",
  initialState: arbitratorAllocation,
  reducers: {
    resetArbitratorAllocation: (state) => {
      state.cases = [];
      state.unmatchedCases = [];
      state.loading = false;
      state.error = "";
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(searchArbitratorAllocationAction.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(searchArbitratorAllocationAction.fulfilled, (state, action) => {
        state.loading = false;
        state.cases = action.payload?.cases || [];
        state.unmatchedCases = action.payload?.unmatchedCases || [];
      })
      .addCase(searchArbitratorAllocationAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(submitArbitratorMappingAction.pending, (state) => {
        state.loading = true;
      })
      .addCase(submitArbitratorMappingAction.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(submitArbitratorMappingAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }),
});

export const { resetArbitratorAllocation } = arbitratorAllocationSlice.actions;
export default arbitratorAllocationSlice.reducer;
